import { Box, Image, Flex, Text, Divider, Heading, VStack, Button } from "@chakra-ui/react";
import { useEffect, useState } from "react";

// Iconos
import { FiPhoneCall } from "react-icons/fi";

// Componentes
import { updateData, postData } from "../../Services/api";

// Imagenes
import logo from '../../Assets/Logos/entel-logo.webp';

const Estrategia = () => {
    const [view, setView] = useState(true);
    const [idSave, setIdSave] = useState(0);

    const queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    
    let tipo = urlParams.get('tipo');

    useEffect(async() => {
        const sendData = async() => {
            const insertData = await postData('estrategiaqr', {
                tipo
            });

            if (insertData?.OK) {
                setIdSave(insertData?.ID)
            }
        };

        await sendData();
        if (tipo === 'whatsapp') {
            window.location.replace("https://api.whatsapp.com/send?phone=56979595454&text=Hola%2C+escane%C3%A9+tu+c%C3%B3digo+QR.+Me+gustar%C3%ADa+saber+m%C3%A1s+sobre+sus+productos.+%C2%BFMe+podr%C3%ADas+compartir+m%C3%A1s+informaci%C3%B3n%2C+por+favor%3F");
        } else if (tipo === 'c2c') {
            // setView(true);
            window.location.href = "tel:+56979595454";
        } else {
            window.location.replace('https://entel-ofertas.cl/');
        }
    }, []);

    const handleInteractionUser = async() => {
        await updateData('updateEstrategiaQr', {
            tipo,
            id: idSave
        });
    };
    
    return (
        view &&
        <Box mx='8' mt='8' overflow='hidden'>
            {/* Header */}
            <Flex alignItems='center' justifyContent='space-between'>
                <Image src={logo} maxW='60px' alt='logo entel te conviene' />
                <Flex>
                    <Text h='auto' fontSize='xs' py='3' color='white' px='5' bg='#002eff' borderRadius='30px'>
                        Entel Conviene - Benefico Corporativo
                    </Text>
                </Flex>
            </Flex>

            <Divider mt='7' mb='10' borderColor='#c7c7c7' />

            {/* Body */}
            <VStack spacing='16px' alignItems='left' mx='2'>
                <Heading fontWeight='400' className="General" size='2xl' color='#002eff'>
                    En <b>Entel Conviene</b>,
                    los beneficios son
                    para ti y tu familia 
                </Heading>

                <Text color='#002eff' className="General" fontSize='2xl'>
                    Si tu empresa tiene convenio
                    con Entel, estos beneficios son
                    para ti.
                </Text>

                <Text className="Subtitle" fontSize='xl'>
                    ¿Tienes dudas?
                </Text>

                <Text color='#4B5563' className="General" fontSize='lg'>
                    Llama y lo vemos juntos.
                </Text>
            </VStack>

            <Divider my='10' w='95%' mx='auto' borderColor='#c7c7c7' />

            {/* Footer */}
            <VStack spacing='20px' mx='2' justifyContent='center' textAlign='center'>
                <Text color='#6B7280' className="Subtitle">
                    Te ayudamos a revisar y activar tu beneficio.
                </Text>

                <Button as='a' leftIcon={<FiPhoneCall />} py='4' href={`tel:+56979595454`} _hover={{ bg: '#BECBFF' }} onClick={() => handleInteractionUser()} fontSize='xl' borderRadius='30px' h='auto' bg='#002eff' color='white' className="General" w='100%'>
                    Llamar ahora
                </Button>

                <Text className="Subtitle" fontSize='lg'>
                    O llama al <>+56 9 79595454</>
                </Text>

                <Text color='#6B7280' className="General">
                    Toca el botón para llamar.
                </Text>
            </VStack>

            <Divider mt='10' w='95%' mx='auto' borderColor='#c7c7c7' />
        </Box>
    )
}

export default Estrategia;